import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import Schema from './schema';
import PrazoView from './View';
import { etapaDeInscricao, lerCronograma } from './cronograma';

export const NOTA_PADRAO =
  'Datas prováveis; podem mudar com publicação oficial.';

// Lê o texto colado e devolve o bloco com o cronograma novo (que substitui o
// anterior: é o caminho de uma retificação) e, se pedido, o prazo principal
// tirado da etapa de inscrição.
export const aplicarCronograma = (data, texto, usarInscricao) => {
  const ano = data?.dataFim
    ? Number(data.dataFim.slice(0, 4))
    : new Date().getFullYear();
  const { etapas, ignoradas } = lerCronograma(texto, ano);
  if (!etapas.length) return { data, etapas, ignoradas };
  const novo = { ...data, etapas };
  const inscricao = usarInscricao ? etapaDeInscricao(etapas) : null;
  if (inscricao) {
    novo.dataInicio = inscricao.inicio;
    novo.dataFim = inscricao.fim;
  }
  if (!(data?.nota || '').trim()) novo.nota = NOTA_PADRAO;
  return { data: novo, etapas, ignoradas };
};

/** Edit do Prazo de edital: o desenho do View, os campos na barra lateral e o
 *  painel "Colar o cronograma" abaixo do bloco. */
const PrazoEdit = ({ data, onChangeBlock, block, selected }) => {
  const schema = Schema();
  const [colado, setColado] = useState('');
  const [usarInscricao, setUsarInscricao] = useState(true);
  const [resultado, setResultado] = useState(null);

  const ler = () => {
    const r = aplicarCronograma(data, colado, usarInscricao);
    setResultado({ n: r.etapas.length, ignoradas: r.ignoradas });
    if (r.etapas.length) {
      onChangeBlock(block, r.data);
      setColado('');
    }
  };
  // Enter e Esc no painel não sobem ao formulário da página.
  const naoSubir = (e) => e.stopPropagation();

  return (
    <>
      <PrazoView
        data={data}
        vazio={
          <p className="ag-prazo__vazio">
            Prazo de edital: preencha o encerramento na barra lateral ou cole o
            cronograma abaixo.
          </p>
        }
      />
      {selected && (
        <div className="ag-prazo__colar" onKeyDown={naoSubir}>
          <label htmlFor={`colar-${block}`}>Colar o cronograma</label>
          <p>
            Copie a tabela do cronograma no PDF do edital (ou da retificação) e
            cole aqui. Colar de novo substitui o cronograma.
          </p>
          <textarea
            id={`colar-${block}`}
            rows={6}
            value={colado}
            onChange={(e) => setColado(e.target.value)}
          />
          <label className="ag-prazo__colar-opcao">
            <input
              type="checkbox"
              checked={usarInscricao}
              onChange={(e) => setUsarInscricao(e.target.checked)}
            />{' '}
            Usar a etapa de inscrição como prazo principal
          </label>
          <button type="button" onClick={ler} disabled={!colado.trim()}>
            Ler o cronograma
          </button>
          {resultado && (
            <p className="ag-prazo__colar-resultado" role="status">
              {resultado.n
                ? `${resultado.n} etapas lidas.`
                : 'Nenhuma etapa com data foi encontrada no texto colado.'}
              {resultado.ignoradas.length > 0 &&
                ` Ficou de fora: ${resultado.ignoradas.join(' / ')}`}
            </p>
          )}
        </div>
      )}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

PrazoEdit.propTypes = {
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

export default PrazoEdit;
